(function () {
  'use strict';

  var disclosureButtons = document.querySelectorAll('[data-muld-disclosure]');

  Array.prototype.forEach.call(disclosureButtons, function (button) {
    button.addEventListener('click', function () {
      var panelId = button.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      var isOpen = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });
  });

  var hash = window.location.hash;
  if (hash) {
    var target = document.querySelector(hash);
    if (target && target.hasAttribute('hidden')) {
      target.hidden = false;
      var opener = document.querySelector('[aria-controls="' + target.id + '"]');
      if (opener) opener.setAttribute('aria-expanded', 'true');
    }
  }
}());
